import { combineReducers } from "redux";
import coinReducer from "./coinSlice";
import characterReducer from "./characterSlice";
import imagesReducer from "./imagesSlice";
import notificationsReducer from "./notificationsSlice";
import modalsReducer from "./modalsSlice";
import lorasReducer from "./lorasSlice";
import composerReducer from "./composerSlice";

const rootReducer = combineReducers({
  coin: coinReducer,
  characters: characterReducer,
  images: imagesReducer,
  notifications: notificationsReducer,
  modals: modalsReducer,
  loras: lorasReducer,
  compositions: composerReducer,
});

export default rootReducer;
